<div class="row">
  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" *ngFor="let drop of curentGungFlow.drops">
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h2 class="mb-0">{{ drop.id }}: {{ drop.name }}</h2>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          title="{{ 'DELETE' | translate }}"
          (click)="removeDrop(drop)"
        >
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>
      <div class="col-12">
        <lib-gung-text-input gungTranslate="DROP_NAME" [(ngModel)]="drop.name" [placeholder]="'DROP_NAME' | translate">
        </lib-gung-text-input>
      </div>
      <div class="col-12">
        <lib-delivery-date-picker
          id="flow-drop-date"
          [label]="'FIRST_DELIVERY_DATE'"
          [initialDate]="drop.firstDeliveryDate"
          (selectedDate)="dateSelected($event, drop)"
        >
        </lib-delivery-date-picker>
      </div>
    </div>
  </div>
  <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
    <div class="add-drop d-flex flex-column justify-content-center align-items-center" (click)="addDrop()">
      <i class="fal fa-plus fa-5x add-drop-icon"></i>
      <span class="add-drop-label">{{ 'ADD_DROP' | translate }}</span>
    </div>
  </div>
</div>
